import { useCallback } from 'react';
import { FormikProps } from 'formik';

import { IValues } from '../../utils/common/types';
import { ToolCategory } from '../common/types';
import useStore from '../../services/store';
import { getRephrasedTexts } from '../common/completions';
import analytics from '../../services/analytics';
import { getCategoryName } from '../common/category';
import displaySubmitError from '../common/submitError';

type UseRephraseArgs = {
  formProps: FormikProps<IValues>;
};

function useRephrase({ formProps }: UseRephraseArgs) {
  const addRephrases = useStore((state) => state.addRephrases);
  const setIsRephrasing = useStore((state) => state.setIsRephrasing);
  const showGenericError = useStore((state) => state.showGenericError);

  const generateRephrasedText = useCallback(
    async (id: string, textToRephrase: string, showWordCount: boolean, category: ToolCategory) => {
      try {
        setIsRephrasing({ id, category, value: true });
        const { rephrasedResults, tokenInformation } = await getRephrasedTexts(
          category,
          textToRephrase,
          formProps.values.tone,
          showWordCount,
        );

        analytics.rephraseThis({
          page_path: window.location.pathname,
          text_to_rephrase: textToRephrase,
          category_name: getCategoryName(category),
          token_information: tokenInformation,
        });

        addRephrases({
          id,
          rephrasedResults,
          category,
        });
      } catch (err) {
        displaySubmitError({ err, showGenericError, type: 'rephrase' });
      }
      setIsRephrasing({ id, category, value: false });
    },
    [showGenericError, formProps.values],
  );

  return generateRephrasedText;
}

export default useRephrase;
